import React from 'react'
import PropTypes from 'prop-types'
import { GridMain, Item } from './index.style'

const BrandsGrid = ({items}) => {
  return (
    <GridMain>
      {React.Children.toArray(
        items.map((item, itemIndex) => (
          <Item
          >
            {item}
          </Item>
        ))
      )}
    </GridMain>
  )
}

BrandsGrid.propTypes = {
  items: PropTypes.array,
}

export default BrandsGrid
